import { useEffect, useState } from 'react';
import { findActiveBlogs, findAllImage } from '../../api/apiService';
import { useNavigate } from 'react-router-dom';
import dateIcon from '../../assets/date.svg';

const extractCleanText = (html) => {
    if (!html) return '';
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const text = temp.textContent || temp.innerText || '';
    return text.replace(/\s+/g, ' ').trim();
};

export default function Blogs() {
    const [blogPosts, setBlogPosts] = useState([]);
    const [imageUrls, setImageUrls] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
const findData = async () => {
    setIsLoading(true);
    try {
        const res = await findActiveBlogs();
        
        const filteredPosts = (res?.data || []).filter(post => 
            post && 
            post.date && 
            post.isActive === true
        );
        
        if (filteredPosts.length === 0) {
            setBlogPosts([]);
            return;
        }
        const sortedDescending = filteredPosts.sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
        });
        const featured = sortedDescending[0];
        const remaining = sortedDescending.slice(1);

        const finalPosts = [featured, ...remaining].filter(Boolean);
        
        setBlogPosts(finalPosts);
    } catch (error) {
        setBlogPosts([]);
    } finally {
        setIsLoading(false);
    }
};




    const renderAllImage = async (ids) => {
        if (!ids || ids.length === 0) return [];
        const idArray = Array.isArray(ids) ? ids : [ids];
        const validIds = idArray.filter(id => id);
        if (validIds.length === 0) return [];
        
        const idsParam = validIds.join(",");
        const res = await findAllImage(idsParam);
        return res?.data?.[0]?.data || [];
    };

    useEffect(() => {
        findData();
    }, []);
useEffect(() => {
    const fetchImages = async () => {
        if (!blogPosts || blogPosts.length === 0) return;

        const imageMap = {};
        const allImageIds = [];

        blogPosts.forEach((post, index) => {
            if (!post) return;
            
            if (post.image) {
                imageMap[post.image] = { index, type: 'image' };
                allImageIds.push(post.image);
            }
        });

        if (allImageIds.length === 0) return;

        const fetchedImages = await renderAllImage(allImageIds);
        const urlLookup = {};
        
        fetchedImages.forEach((imageUrl, idx) => {
            const imageId = allImageIds[idx];
            const mapping = imageMap[imageId];
            if (mapping) {
                if (!urlLookup[mapping.index]) {
                    urlLookup[mapping.index] = {};
                }
                urlLookup[mapping.index][mapping.type] = imageUrl;
            }
        });

        setImageUrls(urlLookup);
    };

    fetchImages();
}, [blogPosts]);


    const handleReadMore = (slug) => {
        navigate(`/blogs/${slug}`);
    };

    const formatDate = (dateValue) => {
        if (!dateValue) return '';
        const dateObj = new Date(dateValue);
        return dateObj.toLocaleDateString('en-GB', { 
            day: 'numeric', 
            month: 'short', 
            year: 'numeric' 
        });
    };

   const getImageUrl = (index) => {
    return imageUrls[index]?.image || null;
};

    if (isLoading) {
        return (
            <section className="bg-[#F0F0E5] min-h-screen py-8 sm:py-12 md:py-16 px-3 sm:px-4">
                <div className="max-w-6xl mx-auto flex flex-col justify-center gap-6 sm:gap-8">
                    <div className="bg-gray-200 border border-white rounded-2xl h-48 sm:h-60 md:h-64 shadow-sm skeleton-load" />
                </div>
            </section>
        );
    }

    if (!isLoading && blogPosts.length === 0) {
        return (
            <section className="bg-[#F0F0E5] min-h-screen py-16 px-4">
                <div className="max-w-6xl mx-auto text-center">
                    <h1 className="text-3xl font-bold text-[#F37934] mb-8 font-cinzel">
                        Our Blogs
                    </h1>
                    <div className="bg-gradient-to-br from-[#F0F0E5] via-[#FFFFFF] to-[#F0F0E5] border border-white rounded-2xl px-6 sm:px-10 py-10 sm:py-12 max-w-3xl mx-auto shadow-sm">
                        <h2 className="text-2xl font-bold text-[#56453F] mb-4 font-cinzel uppercase">
                            No Blogs Available
                        </h2>
                        <p className="text-[#56453F] text-sm sm:text-base leading-relaxed">
                            We are curating fresh content. Please check back soon for the latest updates.
                        </p>
                    </div>
                </div>
            </section>
        );
    }

    const featuredPost = blogPosts[0];

    return (
        <section className="bg-[#F0F0E5] min-h-screen py-8 sm:py-12 md:py-16 px-3 sm:px-4">
            <div className="max-w-6xl mx-auto">
                <h1 
                    className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#F37934] text-center mb-8 sm:mb-10 md:mb-12 font-cinzel"
                    data-aos="fade-down"
                    data-aos-duration="800"
                >
                    Our Blogs
                </h1>
                {featuredPost && (
                    <div 
                        className="bg-gradient-to-br from-[#F0F0E5] via-[#FFFFFF] to-[#F0F0E5] border border-white rounded-2xl p-4 mb-8 sm:mb-12 md:mb-16 w-full max-w-6xl mx-auto"
                        data-aos="zoom-in"
                        data-aos-duration="800"
                    >
                        <div className="flex flex-col md:flex-row md:h-64 md:gap-12">
                            {getImageUrl(0) && (
                                <div className="w-full md:w-[40%] lg:w-[40%] h-48 sm:h-56 md:h-full flex-shrink-0">
                                    <img 
                                        src={getImageUrl(0)} 
                                        alt={featuredPost.heading}
                                        className="w-full h-full object-cover rounded-2xl"
                                    />
                                </div>
                            )}
                            <div className="w-full md:w-[60%] lg:w-[60%] p-4 sm:p-5 md:py-4 md:pr-4 md:pl-0 flex flex-col justify-center text-left">
                                {featuredPost.date && (
                                    <div className="flex items-center text-[#F37934] text-xs sm:text-sm mb-2">
                                        <img 
                                            src={dateIcon} 
                                            alt="Date" 
                                            className="w-4 h-4 mr-2"
                                        />
                                        <span className='text-[#56453F]'>{formatDate(featuredPost.date)}</span>
                                    </div>
                                )}
                                <h2 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-[#56453F] mb-2 font-cinzel uppercase line-clamp-2 text-left">
                                    {featuredPost.heading}
                                </h2>
                                {featuredPost.content && (
                                    <p className="text-[#56453F] text-xs sm:text-sm md:text-base mb-3 md:mb-4 leading-relaxed line-clamp-2 md:line-clamp-3 text-left">
                                        {extractCleanText(featuredPost.content).substring(0, 150)}...
                                    </p>
                                )}
                                <button 
                                    onClick={() => handleReadMore(featuredPost.slug)}
                                    className="bg-[#F37934] text-white px-4 sm:px-5 md:px-6 py-1.5 sm:py-2 rounded-md hover:bg-[#d66a2a] transition-colors text-xs sm:text-sm font-medium w-fit"
                                >
                                    More Details
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {blogPosts.length > 1 && (
                    <div className="mb-12 md:mb-16">
                        <h2 
                            className="text-xl sm:text-2xl md:text-3xl font-bold text-[#F37934] mb-10 md:mb-10 font-cinzel text-left"
                            data-aos="fade-right"
                            data-aos-duration="800"
                        >
                            Recent Post
                        </h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-12 justify-items-center">
                            {blogPosts.slice(1).map((post, index) => {
                                const actualIndex = index + 1;
                                const imageUrl = getImageUrl(actualIndex);
                                
                                return (
                                    <article
                                        key={post._id || index}
                                        className="bg-gradient-to-br from-[#F0F0E5] via-[#FFFFFF] to-[#F0F0E5] border border-white rounded-2xl p-4 cursor-pointer flex flex-col w-full max-w-[380px] h-[320px]"
                                        onClick={() => handleReadMore(post.slug)}
                                        data-aos="fade-up"
                                        data-aos-duration="800"
                                        data-aos-delay={100 * (index + 1)}
                                    >
                                        <div className="w-full h-[60%] flex items-center justify-center overflow-hidden mb-4 flex-shrink-0">
                                            {imageUrl ? (
                                                <img 
                                                    src={imageUrl} 
                                                    alt={post.heading}
                                                    className="w-full h-full object-cover rounded-xl"
                                                />
                                            ) : (
                                                <div className="w-full h-full bg-gray-100 flex items-center justify-center rounded-xl">
                                                    <span className="text-gray-300 text-sm">No Image</span>
                                                </div>
                                            )}
                                        </div>

                                        <div className="flex flex-col flex-grow text-left px-4 py-3 h-[40%]">
                                            {post.date && (
                                                <div className="flex items-center text-[#F37934] text-xs mb-3">
                                                    <img 
                                                        src={dateIcon} 
                                                        alt="Date" 
                                                        className="w-4 h-4 mr-2"
                                                    />
                                                    <span className="text-[#56453F]">{formatDate(post.date)}</span>
                                                </div>
                                            )}
                                            
                                            <h3 className="text-sm sm:text-base font-bold text-[#56453F] font-cinzel line-clamp-4 uppercase text-left leading-snug">
                                                {post.heading}
                                            </h3>
                                        </div>
                                    </article>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
